import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';

import Button from './../Inputs/Button';
import TextInput from './../Inputs/TextInput';
import { required, minLength } from '../../../utils/validators';
import i18n from '../../../i18n/i18n.js';

const GdprPasswordForm = props => {
    const lng = props.lng;

    return (
        <Fragment>
            <form onSubmit={props.handleSubmit}>
                <section id="ipx-maincontent" className="gdpr-text">
                    <h2>Please enter your password</h2>
                    <Field
                        type="password"
                        name="password"
                        label={i18n.t('placeholder_password', { lng })}
                        component={TextInput}
                        className="labelholder pswresetfield"
                        validate={required}
                        lng={lng}
                        handleFocus={props.handleFocus}
                        active={
                            props.name === 'password' ? props.active : false
                        }
                        primaryColor={props.branding.paywall_primary_color}
                    />
                    <div className="buttonholder buttonholder-gdpr">
                        <a href="#" onClick={props.back} className="back">
                            〈 BACK
                        </a>
                        <Button
                            text={i18n.t('confirm', { lng })}
                            backgroundColor={
                                props.branding.paywall_buttons_bg_color
                            }
                            touched={props.params && props.params.anyTouched}
                            errors={
                                props.params && props.params.syncErrors
                                    ? true
                                    : false
                            }
                            isLoading={props.isLoading}
                        />
                    </div>
                </section>
            </form>
        </Fragment>
    );
};

export default reduxForm({
    form: 'gdprPasswordForm',
    initialValues: {
        props: [{}],
    },
})(GdprPasswordForm);



// WEBPACK FOOTER //
// ./src/ui/components/Forms/GdprPassword.js